import ActionText from '@/atoms/ActionText/ActionText';
import {useState} from 'react';
import {
  StyledAboutAwards,
  StyledAccordion,
  StyledAwardDescription,
  StyledAwardTitle,
  StyledAwardYear,
  StyledBody,
  StyledTitle,
} from './styles';
import {AboutAwardsArtistPageProps, AwardComponentProps, AwardsProps} from './typings';

const Award = ({award}: AwardComponentProps): JSX.Element => {
  return (
    <>
      <StyledAwardYear>{award.year}</StyledAwardYear>

      <StyledAwardTitle>{award.title}</StyledAwardTitle>

      {award.description && <StyledAwardDescription>{award.description}</StyledAwardDescription>}
    </>
  );
};

const Awards = ({awards, showAllAwards, toggleCallback, keyPrefix}: AwardsProps): JSX.Element => {
  const [firstAward, ...remainingAwards] = awards;

  return (
    <>
      <Award award={firstAward} />

      {remainingAwards.length > 0 && (
        <>
          <ActionText onClick={toggleCallback}>
            {showAllAwards ? 'Hide' : 'Show more awards'}
          </ActionText>

          {showAllAwards && (
            <>
              {remainingAwards.map((award, i) => (
                <Award key={`${keyPrefix}-award-${i}`} award={award} />
              ))}
            </>
          )}
        </>
      )}
    </>
  );
};

const AboutAwardsArtistPage = ({
  awards,
  className,
}: AboutAwardsArtistPageProps): JSX.Element | null => {
  const [showAllAwards, setShowAllAwards] = useState(false);
  const title = 'Awards';

  const toggleAwards = () => setShowAllAwards((prev) => !prev);

  return !!awards?.length ? (
    <>
      <StyledAboutAwards className={className}>
        <StyledTitle>{title}</StyledTitle>

        <StyledBody>
          <Awards
            awards={awards}
            showAllAwards={showAllAwards}
            toggleCallback={toggleAwards}
            keyPrefix={'desktop'}
          />
        </StyledBody>
      </StyledAboutAwards>

      <StyledAccordion title={title} strongTitle={false} className={className}>
        <Awards
          awards={awards}
          showAllAwards={showAllAwards}
          toggleCallback={toggleAwards}
          keyPrefix={'mobile'}
        />
      </StyledAccordion>
    </>
  ) : null;
};

export default AboutAwardsArtistPage;
